import React from "react";

const Leasing = () => {
  return (
    <div className="leasing">
      <h2>Leasing (LLD/LOA)</h2>
      <p>Gestion des contrats de leasing.</p>
    </div>
  );
};

export default Leasing;
